module.exports = __webpack_public_path__ + "static/media/stream.ce7bf370.png";